"use strict";

/**
* Кнопка панели "Создать".
*
* @class WebAccess.components.ActionButton
* @extends BaseObject
* @property {object} _model Модель кнопки панели "Создать"
*/

(function (global) {
  var ActionButton = BaseObject.extend({

    _model: {},
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Конструктор
     * @param {object} model Модель кнопки панели "Создать"
     * @method WebAccess.components.ActionButton#init
     */
    init: function (model) {
      this._model = model;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Признак скрытия объекта.
     *
     * @method WebAccess.components.ActionButton#isHidden
     * @return {boolean} True, если объект скрыт, иначе False.
     */
    isHidden: function () {
      return this._model.hidden;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Признак отображения объекта.
     *
     * @method WebAccess.components.ActionButton#isEnabled
     * @return {boolean} True, если объект отображается, иначе False.
     */
    isEnabled: function () {
      return !this._model.disabled;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Отобразить скрытый объект.
     *
     * @method WebAccess.components.ActionButton#show
     * @return {WebAccess.components.ActionButton} Объект типа ActionButton.
     *
     * @example
     * WebAccess.current.createPanel.buttons['CrtDocTmpl'].show();
     */
    show: function () {
      this._model.hidden = false;
      this._dispatchChangeEvent();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Скрыть объект.
     *
     * @method WebAccess.components.ActionButton#hide
     * @return {WebAccess.components.ActionButton} Объект типа ActionButton.
     */
    hide: function() {
      this._model.hidden = true;
      this._dispatchChangeEvent();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Сделать кнопку недоступной.
     * Кнопка становится полупрозрачной и не реагирует на события.
     *
     * @method WebAccess.components.ActionButton#disable
     * @return {WebAccess.components.ActionButton} Объект типа ActionButton.
     */
    disable: function() {
      this._model.disabled = true;
      this._dispatchChangeEvent();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Сделать кнопку доступной.
     *
     * @method WebAccess.components.ActionButton#enable
     * @return {WebAccess.components.ActionButton} Объект типа ActionButton.
     */
    enable: function () {
      this._model.disabled = false;
      this._dispatchChangeEvent();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Добавить подпись к объекту.
     *
     * @param {string} text Текст подписи
     * @method WebAccess.components.ActionButton#setLabel
     * @return {WebAccess.components.ActionButton} Объект типа ActionButton.
     */
    setLabel: function (text) {
      this._model.text = text;
      this._dispatchChangeEvent();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получить текст подписи объекта.
     *
     * @method WebAccess.components.ActionButton#getLabel
     * @return {string} Текст подписи объекта.
     */
    getLabel: function () {
      return this._model.text;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
     * Установить всплывающую подсказку.
     *
     * @param {string} text Текст всплывающей подсказки
     * @method WebAccess.components.ActionButton#setTooltip
     * @return {WebAccess.components.ActionButton} Объект типа ActionButton.
     * @since 5.0.0.4005
     */
    setTooltip: function (text) {
      this._model.tooltip = text;
      this._dispatchChangeEvent();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получить текст всплывающей подсказки.
     *
     * @method WebAccess.components.ActionButton#getTooltip
     * @return {string} Текст всплывающей подсказки.
     * @since 5.0.0.4005
     */
    getTooltip: function () {
      return this._model.tooltip;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Установить иконку.
     *
     * Иконку необходимо разместить в папке проекта App_Sprites и после скомпилировать проект.
     * Либо можно использовать название svg-спрайта.
     *
     * @example
     * WebAccess.current.createPanel.buttons['CrtDocTmpl'].setIcon('SidebarAndExtensions/EDocumentSearch_24.png');
     * или
     * WebAccess.current.createPanel.buttons['CrtDocTmpl'].setIcon('task-32');
     *
     * @param {string} path Путь к иконке или название svg-спрайта
     * @method WebAccess.components.ActionButton#setIcon
     * @return {WebAccess.components.ActionButton} Объект типа ActionButton.
     */
    setIcon: function (path) {
      this._model.icon = path;
      this._dispatchChangeEvent();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получить имя иконки.
     *
     * @method WebAccess.components.ActionButton#getIcon
     * @return {string} Имя иконки.
     */
    getIcon: function() {
      return this._model.icon;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Назначить функцию на клик.
     *
     * @param {string} callback Функция, исполняемая при клике, передаваемая в виде строки.
     * @method WebAccess.components.ActionButton#getIcon
     * @return {WebAccess.components.ActionButton} Объект типа ActionButton.
     */
    click: function(callback) {
      var instance = this;
      if (callback) {
        this._model.jsaction = callback;
        this._dispatchChangeEvent();
      } else {
        // TODO: сэмулировать клик каким-то образом.
      }
      return this;
    },

    /**
     * Вызвать событие, которое оповещает подписчиков об изменениях в модели кнопки.
     *
     * // Вызванное событие повлечет за собой рендер ExplorerHeader с помощью react (ВД 5.5.0).
     */
    _dispatchChangeEvent: function() {
      this.fire(this['class'].EVENT.CHANGE_STATE);
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  }, {
      /**
       * События.
       */
      EVENT: {
        /**
         * Изменилось свойство кнопки.
         */
        CHANGE_STATE: 'changeState'
      }
    });

  global.ActionButton = ActionButton;

})(window.WebAccess.components);
